import React from 'react';
import styles from './backdrop.module.css';
import { CSSTransition } from 'react-transition-group';

interface IBackdropProps {
  open: boolean;
  onClose: () => void;
  bgStyle?: string;
  height?: string;
}

export function Backdrop({ open, onClose, bgStyle = 'rgba(0, 0, 0, 0.315)', height = '100dvh' }: IBackdropProps) {
  const nodeRef = React.useRef<HTMLDivElement>(null);

  const classNames = {
    enter: styles.nodeEnter,
    enterActive: styles.nodeEnterActive,
    exit: styles.nodeExit,
    exitActive: styles.nodeExitActive,
  };

  return (
    <CSSTransition
      in={open}
      timeout={300}
      classNames={classNames}
      nodeRef={nodeRef}
      mountOnEnter
      unmountOnExit
      appear
    >
      <div
        ref={nodeRef}
        className={styles.backDrop}
        style={{ backgroundColor: bgStyle, height }}
        onClick={onClose} // клик по Backdrop закрывает модалку
      />
    </CSSTransition>
  );
}